import { render } from "./ProductCard.vue?vue&type=template&id=16bf985d"
const script = {}

import "./ProductCard.vue?vue&type=style&index=0&id=16bf985d&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__